// extracted by mini-css-extract-plugin
module.exports = {"PriceTagSvg":"PriceTagSvg_PriceTagSvg__2qypq","HELP":"PriceTagSvg_HELP__1cDEO","TEACH":"PriceTagSvg_TEACH__3YalW","RENT":"PriceTagSvg_RENT__31SLT","MAKE":"PriceTagSvg_MAKE__3QkyN"};